export const types = {
  FETCH_PROMOTION_BANNER: 'FETCH_PROMOTION_BANNER',
  FETCH_PROMOTION_BANNER_SUCCESS: 'FETCH_PROMOTION_BANNER_SUCCESS',
  CLOSE_PROMOTION_BANNER: 'CLOSE_PROMOTION_BANNER',
  OPEN_PROMOTION_BANNER: 'OPEN_PROMOTION_BANNER',
};
const initialBanner = {
  clickType: '',
  link: '',
  desc: '',
  linkText: '',
};

export const fetchPromotionBanner = page => ({
  type: types.FETCH_PROMOTION_BANNER,
  payload: { page },
});

export const fetchPromotionBannerSuccess = (bannerName, value) => ({
  type: types.FETCH_PROMOTION_BANNER_SUCCESS,
  payload: {
    [bannerName]: value || initialBanner,
  },
});

export const closePromotionBanner = () => ({
  type: types.CLOSE_PROMOTION_BANNER,
});

export const openPromotionBanner = () => ({
  type: types.OPEN_PROMOTION_BANNER,
});

/**
 * @typedef {object} InitialState
 * @property {boolean} isOpen
 * @property {Banner} homeBanner
 * @property {Banner} pricingBanner
 */

/** @type {InitialState} */
const initialState = {
  isOpen: false,
  homeBanner: initialBanner,
  pricingBanner: initialBanner,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROMOTION_BANNER_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLOSE_PROMOTION_BANNER:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN_PROMOTION_BANNER:
      return {
        ...state,
        isOpen: true,
      };
    default:
      return state;
  }
};

export default reducer;

export const getHomeBanner = state => state.promotionBanner.homeBanner;
export const getPricingBanner = state => state.promotionBanner.pricingBanner;
export const getPromotionBannerIsOpen = state => state.promotionBanner.isOpen;



// WEBPACK FOOTER //
// ./app/redux/promotionBanner.js